import { useCallback, useEffect, useState } from 'react';

import {
  COLLAPSE_STORAGE_KEY,
  SIDEBAR_WIDTH_VAR,
  SIDEBAR_WIDTH_VAR_COLLAPSED,
  SIDEBAR_WIDTH_VAR_EXPANDED,
} from './constants';

function readStored(): boolean {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(COLLAPSE_STORAGE_KEY) === 'true';
}

// Owns the sidebar's collapsed/expanded state, persisting it to localStorage
// under the same key the old Stimulus controller used. Replaces
// sidebar_controller.js's connect()/toggle()/localStorage handling.
export function useSidebarCollapse() {
  const [collapsed, setCollapsed] = useState<boolean>(readStored);

  // Persist the preference and keep the --sidebar-width CSS variable in sync so
  // fixed preview footers stay aligned (the old Stimulus controller's job).
  useEffect(() => {
    window.localStorage.setItem(COLLAPSE_STORAGE_KEY, String(collapsed));
    document.documentElement.style.setProperty(
      SIDEBAR_WIDTH_VAR,
      collapsed ? SIDEBAR_WIDTH_VAR_COLLAPSED : SIDEBAR_WIDTH_VAR_EXPANDED,
    );
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsed((prev) => !prev), []);

  return { collapsed, toggle };
}
